// @flow

import React, {Component, Fragment} from 'react';
import gql from 'graphql-tag';
import {FormattedMessage} from 'react-intl';
import PriceSummary from '@homeaway/react-price-summary';
import './Price.less';
import {currencyFormatter} from '@homeaway/hacommons-i18n';

export const fragments = {
    SERPHit: gql`
        fragment PriceSERPHit on SERPHit {
            price {
                currencyUnits
                periodType
                value
            }
            priceSummary {
                edapEventJson
                formattedAmount
                pricePeriodDescription
            }
        }
    `
};

export type Shape = {
    currencyUnits: string,
    periodType: string,
    value: number
};

export type PriceSummaryShape = {
    edapEventJson: string,
    formattedAmount: string,
    pricePeriodDescription: string
};

export type Props = {
    price: ?Shape,
    priceSummary: ?PriceSummaryShape,
    useAverage?: boolean,
    useShort?: boolean,
    locale: string
};

const TOTAL_PERIOD_TYPE = 'TOTAL';

const PeriodFormatted = ({useAverage, useShort, useTotal}) => {
    let id;

    if (useShort) {
        id = 'ratesNightlyShort';
    } else {
        id = useAverage ? 'ratesAverage' : 'ratesNightly';
    }

    if (useTotal) {
        id = 'ratesTotal';
    }

    return (
        <FormattedMessage
            id={id}
            description={'price period'}
            defaultMessage={'avg/night'}
        >
            {(txt) => <Fragment>{txt}</Fragment>}
        </FormattedMessage>
    );
};
export class Price extends Component<Props> {
    render() {
        if (this.props.priceSummary) {
            return <PriceSummary priceSummary={this.props.priceSummary} />;
        }

        /* the following node-hacommons-i18n can directly produce the correct currency format and symbol given
        the locale and the currency (e.g., 'USD').  */
        const {price, useAverage, useShort, locale} = this.props;
        const {currencyUnits, value, periodType} = price || {};

        if (currencyUnits && value) {
            const useTotal = periodType === TOTAL_PERIOD_TYPE;

            return (
                <span className="Price">
                    <span
                        className="Price__value"
                        data-wdio="Price"
                        data-price={value}
                    >
                        {currencyFormatter.formatNumber({
                            value,
                            currencyCode: currencyUnits,
                            locale
                        })}
                    </span>
                    <span className="Price__period">
                        <PeriodFormatted
                            useAverage={useAverage}
                            useTotal={useTotal}
                            useShort={useShort}
                        />
                    </span>
                </span>
            );
        }

        return (
            <span className="Price" data-wdio="Price" data-price="0">
                <FormattedMessage
                    id={'ratesNone'}
                    description={'price period'}
                    defaultMessage={'avg/night'}
                >
                    {(txt) => (
                        <span className="Price_noPrice">
                            {value} {txt}
                        </span>
                    )}
                </FormattedMessage>
            </span>
        );
    }
}

export default Price;
